<p-card>

  <!--
            <p-button (click)="show('Add','')"
                styleClass="customAdd p-button-sm p-button-raised mr-1"
                icon="fa fa-plus p-button-icon ng-star-inserted" pTooltip="Add Version Update"
                tooltipPosition="left"></p-button>
  -->

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 breadcrumbrightmenu flex align-items-right">
      <div class="flex align-items-right" style="margin-left: auto;margin-right: 4;"> 
        <button pTooltip="Help" tooltipPosition="left" aria-hidden="true" class="fa fa-question helpicon"
          (click)="helpservice.openhelpmodal(ref, dialogService, 'Help', 9)">
        </button>
      </div>
    </div>
  </div>


  <p-accordion value="0">
    <p-accordionTab [(selected)]="isExpanded" [disabled]="false">
      <ng-template pTemplate="header">
        <div class="header-container" [ngClass]="{'expanded': showMore}">
          <span>Filters
            <span class="bold-red-text">
              {{ isExpanded ? '“Click to Hide Filters”' : '“Click to View Filters”' }}
            </span>
          </span>
          <div class="selected-items-container">
            <span *ngFor="let item of displayedItems;let i = index" class="chip">{{ item }}
              <i class="pi pi-times remove-icon" (click)="removeItem($event, item)"></i>
            </span>
            <span *ngIf="filterseleteditems.length > maxVisibleItems" class="more-chip" (click)="toggleMore($event)">
              {{ showMore ? 'Show Less' : '+' + remainingCount + ' More' }}
            </span>
          </div>
          <p-button class="green-button" pTooltip="Reset" tooltipPosition="bottom" severity="success"
            (click)="refreshData($event)">
            <i class="fa fa-refresh" aria-hidden="true"></i>
          </p-button>

        </div>
      </ng-template>
      <app-versionupdatefilters></app-versionupdatefilters>
    </p-accordionTab>
  </p-accordion>

  <div>
    <div class="circle-container mb-2">
      <span><i class="fa fa-circle" aria-hidden="true" style="color: red;"></i>&nbsp;Not
        Published&nbsp;&nbsp;&nbsp;</span>
      <span><i class="fa fa-circle" aria-hidden="true" style="color: green;"></i>&nbsp;New
        Functionality&nbsp;&nbsp;&nbsp;</span>
      <span><i class="fa fa-circle" aria-hidden="true"
          style="color: orange;"></i>&nbsp;Improvement&nbsp;&nbsp;&nbsp;</span>
      <span><i class="fa fa-circle" aria-hidden="true" style="color: blue;"></i>&nbsp;Security&nbsp;&nbsp;&nbsp;</span>
    </div>
  </div>

  <div class="mr-0">
    <p-table #dt [value]="listarray" [rows]="numberofrowsingrid" [scrollable]="true" scrollDirection="horizontal"
      scrollHeight="{{commonScrollHeight}}"
      [globalFilterFields]="['requirementid','versionname','productinitial','releaseddate','feature','advantageoffeature','usedfunctionality','towhom']"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
      [rowsPerPageOptions]="paginatorArray" dataKey="id" [rowHover]="true" [resizableColumns]="true"
      columnResizeMode="expand" [showCurrentPageReport]="true" [lazy]="true" sortField="releaseddate"
      paginatorLocale="fa-IR" [paginator]="listarray.length>0" [sortOrder]="-1" responsiveLayout="scroll"
      (onPage)="handlePageChange($event)" (onLazyLoad)="gettabledata($event)" [lazy]="true"
      [totalRecords]="totalRecords" [first]="firstrowingrid">


      <!-- search -->
      <ng-template pTemplate="caption">
        <div class="grid table-header1">
          <div class="col-12 md:col-8 sm:col-12 lg:col-8">
            <span class=" p-input-icon-lft">
              <i icon="pi pi-search"></i>
              <input class="form-control" pInputText type="text" id="tablesearch"
                (input)="dt.filterGlobal($any($event.target).value , 'contains'); searchTerm = $any($event.target).value;"
                placeholder="Search in Version Update" class="tablesearch" pTooltip="Enter Search Criteria"
                tooltipPosition="top" />
            </span>
          </div>
          <div class="col-12 lg:col-2 md:col-2 sm:col-12">
            <div class="grid">
              <!--
                <div class="col-6 sm:col-2 md:col-2 lg:col-2" style="text-align: start;">
                 <i class="fa fa-sliders highlightbkg" (click)="showTableColumns()"
                   [pTooltip]="isTableHeaderCustomized ? 'Table Header is customised' : 'Table Columns Customisation: Choose the column which you want to appear on the table grid.'"
                   tooltipPosition="bottom"
                   [ngStyle]="{ 'cursor': 'pointer', 'color': isTableHeaderCustomized ? '#e20b50' : 'black' }"></i>
         <div *ngIf="isActivefilter">
          <app-customcolumnsversionupdate [showcount]="showcount" [hidecount]="hidecount"></app-customcolumnsversionupdate>
        </div>
     </div>
-->

              <div class="col-6 sm:col-12 md:col-6 lg:col-6" style="text-align: start;">
                <div class="iconexcel" pTooltip="Download Data" tooltipPosition="bottom" (click)="exceDownloadModel();">
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-template>


      <ng-template pTemplate="header">
        <tr>
          <th>Action </th>
          <th pResizableColumn pSortableColumn="requirementid">ReqID<p-sortIcon field="requirementid"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="versionname">Version<p-sortIcon field="versionname"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="productinitial">Product<p-sortIcon field="productinitial"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="releaseddate">Release Date<p-sortIcon field="releaseddate"></p-sortIcon>
          </th>
          <th pResizableColumn pSortableColumn="feature">Feature<p-sortIcon field="feature"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="advantageoffeature">Advantage<p-sortIcon
              field="advantageoffeature"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="usedfunctionality">Functionality<p-sortIcon
              field="usedfunctionality"></p-sortIcon></th>
          <th pResizableColumn pSortableColumn="towhom">To Whom<p-sortIcon field="towhom"></p-sortIcon></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-data>
        <!--                <span class="actionItm" pTooltip="Edit" tooltipPosition="left"> <i class="fa fa-edit"
                    (click)="show('Modify',data)"></i></span>-->
        <tr style="vertical-align: top;">
          <td style="width: 5px !important;">
            <div style="display: flex; gap: 0px;">
              <span *ngIf="data.categoryname ==='Improvement'" pTooltip="{{data.categoryname}}" tooltipPosition="right">
                <i pTooltip="{{data.categoryname}}" tooltipPosition="left" class="fa fa-circle" aria-hidden="true"
                  style="color: orange;"></i>&nbsp;</span>
              <span *ngIf="data.categoryname ==='Security'" pTooltip="{{data.categoryname}}" tooltipPosition="right">
                <i pTooltip="{{data.categoryname}}" tooltipPosition="left" class="fa fa-circle" aria-hidden="true"
                  style="color: blue;"></i>&nbsp;</span>
              <span *ngIf="data.categoryname ==='New Functionality'" pTooltip="{{data.categoryname}}"
                tooltipPosition="right">
                <i pTooltip="{{data.categoryname}}" tooltipPosition="left" class="fa fa-circle" aria-hidden="true"
                  style="color: green;"></i>&nbsp;</span>
              <span *ngIf="data.publishedflag ==='N'" pTooltip="Not published" tooltipPosition="right">
                <i pTooltip="Not published" tooltipPosition="left" class="fa fa-circle" aria-hidden="true"
                  style="color: red;"></i>&nbsp;</span>
            </div>
          </td>

          <td (click)="viewData(data)" style="width: 5% !important;" pTooltip="{{data.requirementid}}">
            {{data["requirementid"] }}</td>
          <td style="width: 5% !important;" pTooltip="{{data.versionname}}"
            [innerHTML]="highlight(data.versionname,searchTerm)"></td>
          <td style="width: 5% !important;" pTooltip="{{data.productinitial}}"
            [innerHTML]="highlight(data.productinitial,searchTerm)"></td>
          <td style="width: 5% !important;" pTooltip="{{data.releaseddate}}"
            [innerHTML]="highlight(data.releaseddate,searchTerm)"></td>
          <td class="wrap-col" style="width: 15% !important;" [innerHTML]="highlight(data.feature,searchTerm)"></td>
          <td class="wrap-col" style="width: 25% !important;"
            [innerHTML]="highlight(data.advantageoffeature,searchTerm)"></td>
          <td class="wrap-col" style="width: 30% !important;"
            [innerHTML]="highlight(data.usedfunctionality,searchTerm)"></td>
          <td style="width: 10% !important;" pTooltip="{{data.towhom}}" [innerHTML]="highlight(data.towhom,searchTerm)">
          </td>
        </tr>
      </ng-template>
      highlight(row.name, searchTerm)"
    </p-table>
  </div>
  <div class="card" style="margin-top: -4px;" *ngIf="listarray.length==0">
    <p-card>
      <p style="text-align: center;">No data available...</p>
    </p-card>
  </div>
</p-card>


<p-dialog header="Excel Download" [(visible)]="exceldownloadModal" [modal]="true" [baseZIndex]="10000"
  [draggable]="true" [resizable]="false" position="top">
  <div class="dialog-content-min-excel" style=" text-align: center !important;">
    <div class="card">
      <p>{{excel_paragraph}}</p>
    </div>
  </div>

</p-dialog>